
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.676 14.112l-3.38-3.382a6.735 6.735 0 001.273-3.947 6.734 6.734 0 00-1.988-4.795A6.738 6.738 0 006.785 0a6.734 6.734 0 00-4.797 1.988A6.737 6.737 0 00.002 6.783a6.74 6.74 0 001.986 4.797 6.74 6.74 0 004.797 1.988 6.72 6.72 0 003.946-1.274l3.381 3.382a1.102 1.102 0 001.564 0 1.106 1.106 0 000-1.564zM3.553 10.016a4.543 4.543 0 01-1.339-3.233A4.54 4.54 0 013.553 3.55a4.539 4.539 0 013.232-1.34 4.54 4.54 0 013.232 1.34 4.542 4.542 0 011.34 3.232 4.54 4.54 0 01-1.34 3.233 4.54 4.54 0 01-3.232 1.339 4.538 4.538 0 01-3.232-1.34z"}})])
          )
        }
      }
    